"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _mediaPipeUtils = _interopRequireWildcard(require("../../util/mediaPipeUtils"));
var _clamp2 = _interopRequireDefault(require("lodash/clamp"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
var mediaPipeUtils = _mediaPipeUtils["default"].getInstance();
Entry.MediaPipeUtils = mediaPipeUtils;
var flipStateTransitions = {
  hflip: [_mediaPipeUtils.flipState.HORIZONTAL, _mediaPipeUtils.flipState.NORMAL, _mediaPipeUtils.flipState.BOTH, _mediaPipeUtils.flipState.VERTICAL],
  vflip: [_mediaPipeUtils.flipState.VERTICAL, _mediaPipeUtils.flipState.BOTH, _mediaPipeUtils.flipState.NORMAL, _mediaPipeUtils.flipState.HORIZONTAL]
};
module.exports = {
  getBlocks: function getBlocks() {
    var params = {
      getCommonIndicator: function getCommonIndicator() {
        return {
          type: 'Indicator',
          img: 'block_icon/ai_video_icon.svg',
          size: 11
        };
      },
      getCameraOrder: function getCameraOrder() {
        return {
          type: 'DropdownDynamic',
          menuName: 'connectedCameras',
          fontSize: 11,
          bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
          arrowColor: EntryStatic.colorSet.common.WHITE
        };
      },
      getVideoFlipOptions: function getVideoFlipOptions() {
        return {
          type: 'Dropdown',
          options: [[Lang.Blocks.video_left_right, 'hflip'], [Lang.Blocks.video_top_bottom, 'vflip']],
          value: 'hflip',
          fontSize: 11,
          bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
          arrowColor: EntryStatic.colorSet.common.WHITE
        };
      },
      getOnOff: function getOnOff() {
        return {
          type: 'Dropdown',
          options: [[Lang.Blocks.video_show_video, 'on'], [Lang.Blocks.video_hide_video, 'off']],
          value: 'on',
          fontSize: 11,
          bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
          arrowColor: EntryStatic.colorSet.common.WHITE
        };
      }
    };
    return {
      media_pipe_title: {
        template: '%1',
        skeleton: 'basic_text',
        color: EntryStatic.colorSet.common.TRANSPARENT,
        params: [{
          type: 'Text',
          text: Lang.Blocks.media_pipe_title_text,
          color: EntryStatic.colorSet.common.TEXT,
          align: 'center'
        }],
        def: {
          type: 'media_pipe_title'
        },
        "class": 'media_pipe',
        isNotFor: ['gestureRecognition', 'poseLandmarker', 'faceLandmarker', 'objectDetector'],
        events: {}
      },
      media_pipe_video_screen: {
        color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
        outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        skeleton: 'basic',
        statements: [],
        params: [params.getOnOff(), params.getCommonIndicator()],
        events: {},
        def: {
          type: 'media_pipe_video_screen'
        },
        paramsKeyMap: {
          VALUE: 0
        },
        "class": 'media_pipe',
        isNotFor: ['gestureRecognition', 'poseLandmarker', 'faceLandmarker', 'objectDetector'],
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
            var value;
            return _regenerator["default"].wrap(function (_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  value = script.getField('VALUE');
                  if (mediaPipeUtils.isInitialized) {
                    _context.next = 1;
                    break;
                  }
                  _context.next = 1;
                  return mediaPipeUtils.initialize();
                case 1:
                  mediaPipeUtils.cameraOnOff(value);
                  return _context.abrupt("return", script.callReturn());
                case 2:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }))();
        },
        wikiClass: 'ai_utilize_video'
      },
      media_pipe_switch_camera: {
        color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
        outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        skeleton: 'basic',
        statements: [],
        params: [params.getCameraOrder(), params.getCommonIndicator()],
        events: {},
        def: {
          type: 'media_pipe_switch_camera'
        },
        paramsKeyMap: {
          VALUE: 0
        },
        "class": 'media_pipe',
        isNotFor: ['gestureRecognition', 'poseLandmarker', 'faceLandmarker', 'objectDetector'],
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
            var value;
            return _regenerator["default"].wrap(function (_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  value = script.getField('VALUE');
                  _context2.next = 1;
                  return mediaPipeUtils.changeSource(value);
                case 1:
                  return _context2.abrupt("return", _context2.sent);
                case 2:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          }))();
        },
        wikiClass: 'ai_utilize_video'
      },
      check_connected_camera: {
        color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
        outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        skeleton: 'basic_boolean_field',
        statements: [],
        params: [],
        events: {},
        def: {
          type: 'check_connected_camera'
        },
        paramsKeyMap: {
          VALUE: 0
        },
        "class": 'media_pipe',
        isNotFor: ['gestureRecognition', 'poseLandmarker', 'faceLandmarker', 'objectDetector'],
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
            return _regenerator["default"].wrap(function (_context3) {
              while (1) switch (_context3.prev = _context3.next) {
                case 0:
                  return _context3.abrupt("return", mediaPipeUtils.videoInputList.length);
                case 1:
                case "end":
                  return _context3.stop();
              }
            }, _callee3);
          }))();
        },
        wikiClass: 'ai_utilize_video'
      },
      media_pipe_flip_camera: {
        color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
        outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        skeleton: 'basic',
        statements: [],
        params: [params.getVideoFlipOptions(), params.getCommonIndicator()],
        events: {},
        def: {
          type: 'media_pipe_flip_camera'
        },
        paramsKeyMap: {
          TARGET: 0
        },
        "class": 'media_pipe',
        isNotFor: ['gestureRecognition', 'poseLandmarker', 'faceLandmarker', 'objectDetector'],
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4() {
            var target, flipState;
            return _regenerator["default"].wrap(function (_context4) {
              while (1) switch (_context4.prev = _context4.next) {
                case 0:
                  target = script.getField('TARGET');
                  if (mediaPipeUtils.isInitialized) {
                    _context4.next = 1;
                    break;
                  }
                  _context4.next = 1;
                  return mediaPipeUtils.initialize();
                case 1:
                  flipState = flipStateTransitions[target][mediaPipeUtils.flipState];
                  mediaPipeUtils.setFlipState(flipState);
                  return _context4.abrupt("return", script.callReturn());
                case 2:
                case "end":
                  return _context4.stop();
              }
            }, _callee4);
          }))();
        },
        wikiClass: 'ai_utilize_video'
      },
      media_pipe_set_opacity_camera: {
        color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
        outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        skeleton: 'basic',
        statements: [],
        params: [{
          type: 'Block',
          accept: 'string',
          defaultType: 'number',
          value: '0'
        }, params.getCommonIndicator()],
        events: {},
        def: {
          type: 'media_pipe_set_opacity_camera'
        },
        paramsKeyMap: {
          VALUE: 0
        },
        "class": 'media_pipe',
        isNotFor: ['gestureRecognition', 'poseLandmarker', 'faceLandmarker', 'objectDetector'],
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5() {
            var value;
            return _regenerator["default"].wrap(function (_context5) {
              while (1) switch (_context5.prev = _context5.next) {
                case 0:
                  value = (0, _clamp2["default"])(script.getNumberValue('VALUE'), 0, 100);
                  if (mediaPipeUtils.isInitialized) {
                    _context5.next = 1;
                    break;
                  }
                  _context5.next = 1;
                  return mediaPipeUtils.initialize();
                case 1:
                  mediaPipeUtils.setOpacityCamera(value);
                  return _context5.abrupt("return", script.callReturn());
                case 2:
                case "end":
                  return _context5.stop();
              }
            }, _callee5);
          }))();
        },
        wikiClass: 'ai_utilize_video'
      },
      media_pipe_motion_value: {
        color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
        outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        skeleton: 'basic_string_field',
        statements: [],
        params: [{
          type: 'Dropdown',
          options: [[Lang.Blocks.video_motion_onself, 'self'], [Lang.Blocks.video_motion_onscreen, 'screen']],
          value: 'self',
          fontSize: 10,
          bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
          arrowColor: EntryStatic.colorSet.common.WHITE
        }, {
          type: 'Dropdown',
          options: [[Lang.Blocks.video_motion_scale, 'total'], [Lang.Blocks.video_motion_direction_horizontal, 'x'], [Lang.Blocks.video_motion_direction_vertical, 'y']],
          value: 'total',
          fontSize: 10,
          bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
          arrowColor: EntryStatic.colorSet.common.WHITE
        }],
        events: {},
        def: {
          type: 'media_pipe_motion_value'
        },
        paramsKeyMap: {
          TARGET: 0,
          TYPE: 1
        },
        "class": 'media_pipe',
        isNotFor: ['gestureRecognition', 'poseLandmarker', 'faceLandmarker', 'objectDetector'],
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6() {
            var target, type, detected, rawX, rawY, absX, absY, _t;
            return _regenerator["default"].wrap(function (_context6) {
              while (1) switch (_context6.prev = _context6.next) {
                case 0:
                  target = script.getField('TARGET');
                  type = script.getField('TYPE');
                  if (mediaPipeUtils.isInitialized) {
                    _context6.next = 1;
                    break;
                  }
                  _context6.next = 1;
                  return mediaPipeUtils.initialize();
                case 1:
                  detected = mediaPipeUtils.totalMotions;
                  if (!(target === 'self')) {
                    _context6.next = 3;
                    break;
                  }
                  _context6.next = 2;
                  return mediaPipeUtils.motionDetect(sprite);
                case 2:
                  detected = _context6.sent;
                  if (detected) {
                    _context6.next = 3;
                    break;
                  }
                  return _context6.abrupt("return", 0);
                case 3:
                  if (!(type === 'total')) {
                    _context6.next = 4;
                    break;
                  }
                  return _context6.abrupt("return", (0, _clamp2["default"])(detected.total / 10, 0, 100000).toString());
                case 4:
                  _context6.prev = 4;
                  rawX = detected.direction.x;
                  if (!mediaPipeUtils.isFlipState('horizontal')) {
                    rawX *= -1;
                  }
                  rawY = detected.direction.y;
                  if (mediaPipeUtils.isFlipState('vertical')) {
                    rawY *= -1;
                  }
                  absX = Math.abs(rawX);
                  absY = Math.abs(rawY);
                  if (!(absX < 20 && absY < 20)) {
                    _context6.next = 5;
                    break;
                  }
                  return _context6.abrupt("return", 0);
                case 5:
                  if (!(type === 'x')) {
                    _context6.next = 6;
                    break;
                  }
                  return _context6.abrupt("return", rawX.toFixed(1).toString());
                case 6:
                  if (!(type === 'y')) {
                    _context6.next = 7;
                    break;
                  }
                  return _context6.abrupt("return", rawY.toFixed(1).toString());
                case 7:
                  return _context6.abrupt("return", 0);
                case 8:
                  _context6.prev = 8;
                  _t = _context6["catch"](4);
                  console.log(detected, _t);
                case 9:
                case "end":
                  return _context6.stop();
              }
            }, _callee6, null, [[4, 8]]);
          }))();
        },
        wikiClass: 'ai_utilize_video'
      }
    };
  }
};